/*
  Wiper Express cross-reference lookup controller.
  Reads window.WX_CROSS_REFERENCE_DATA (loaded from wx-cross-reference-data.js)
  and wires search, filter chips, sort, and table render inside the
  .wx-xref section scope.
*/
(function () {
  'use strict';

  function boot() {
    var section = document.querySelector('.wx-xref');
    if (!section) return;
    var data = window.WX_CROSS_REFERENCE_DATA;
    if (!data || !Array.isArray(data.rows)) {
      console.warn('[wx-xref] dataset not loaded');
      return;
    }

    var ROWS = data.rows;
    var HEADERS = data.headers || ['Part Type', 'Part Number', 'Cross Reference', 'Cross #'];
    var RESULT_LIMIT = 500;

    var input       = section.querySelector('[data-xref-input]');
    var clearBtn    = section.querySelector('[data-xref-clear]');
    var typeRow     = section.querySelector('[data-xref-types]');
    var tableWrap   = section.querySelector('[data-xref-table]');
    var resultCount = section.querySelector('[data-xref-result-count]');
    var totalCount  = section.querySelector('[data-xref-total-count]');

    if (!input || !tableWrap) return;

    var activeType = 'all';
    var sortCol = -1;
    var sortDir = 1;
    var debounceTimer;

    if (totalCount) {
      totalCount.textContent = ROWS.length.toLocaleString() + ' records';
    }

    // Build filter chips
    if (typeRow) {
      var typeSet = {};
      for (var i = 0; i < ROWS.length; i++) {
        var t = ROWS[i][0];
        if (t) typeSet[t] = true;
      }
      var types = ['all'].concat(Object.keys(typeSet).sort());
      types.forEach(function (t) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wx-xref__chip' + (t === 'all' ? ' is-active' : '');
        btn.setAttribute('data-type', t);
        btn.textContent = t === 'all' ? 'All Types' : t;
        btn.addEventListener('click', function () {
          var chips = typeRow.querySelectorAll('.wx-xref__chip');
          for (var k = 0; k < chips.length; k++) chips[k].classList.remove('is-active');
          btn.classList.add('is-active');
          activeType = t;
          render(input.value.trim());
        });
        typeRow.appendChild(btn);
      });
    }

    function esc(s) {
      return (s == null ? '' : String(s))
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }
    function escRe(s) {
      return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    function highlight(text, tokens) {
      if (!tokens.length) return esc(text);
      var r = esc(text);
      tokens.forEach(function (t) {
        r = r.replace(new RegExp('(' + escRe(t) + ')', 'gi'), '<span class="wx-xref__hm">$1</span>');
      });
      return r;
    }

    function render(query) {
      var tokens = query.toLowerCase().split(/\s+/).filter(Boolean);

      var filtered = ROWS.filter(function (row) {
        if (activeType !== 'all' && row[0] !== activeType) return false;
        if (!tokens.length) return true;
        var hay = row.join(' ').toLowerCase();
        return tokens.every(function (t) { return hay.indexOf(t) !== -1; });
      });

      if (sortCol >= 0) {
        filtered = filtered.slice().sort(function (a, b) {
          var av = String(a[sortCol] || '').toLowerCase();
          var bv = String(b[sortCol] || '').toLowerCase();
          var an = parseFloat(av);
          var bn = parseFloat(bv);
          if (!isNaN(an) && !isNaN(bn)) return (an - bn) * sortDir;
          return av.localeCompare(bv) * sortDir;
        });
      }

      var total = ROWS.length;

      if (!filtered.length) {
        var msg = query
          ? 'No results for "<strong>' + esc(query) + '</strong>"'
          : 'No records match this filter.';
        tableWrap.innerHTML =
          '<div class="wx-xref__empty"><div class="wx-xref__empty-icon" aria-hidden="true">&#9678;</div><p>' + msg + '</p></div>';
        if (resultCount) resultCount.innerHTML = '';
        return;
      }

      if (resultCount) {
        var suffix = filtered.length < total
          ? ' of ' + total.toLocaleString() + ' total'
          : '';
        var trunc = filtered.length > RESULT_LIMIT
          ? ' &nbsp;&middot;&nbsp; showing first ' + RESULT_LIMIT
          : '';
        resultCount.innerHTML = '<strong>' + filtered.length.toLocaleString() + '</strong> result'
          + (filtered.length !== 1 ? 's' : '') + suffix + trunc;
      }

      var html = '<table class="wx-xref__table"><thead><tr>';
      HEADERS.forEach(function (h, i) {
        var arrow = sortCol === i ? (sortDir === 1 ? '&#9650;' : '&#9660;') : '&#9650;';
        var cls = sortCol === i ? ' class="is-sorted"' : '';
        html += '<th' + cls + ' data-idx="' + i + '">' + esc(h)
             + '<span class="wx-xref__sortarrow" aria-hidden="true">' + arrow + '</span></th>';
      });
      html += '</tr></thead><tbody>';

      filtered.slice(0, RESULT_LIMIT).forEach(function (row) {
        html += '<tr>';
        row.forEach(function (cell, ci) {
          if (ci === 0) {
            html += '<td><span class="wx-xref__badge">' + highlight(cell, tokens) + '</span></td>';
          } else if (ci === 1) {
            html += '<td class="wx-xref__pn">' + highlight(cell, tokens) + '</td>';
          } else {
            html += '<td>' + highlight(cell, tokens) + '</td>';
          }
        });
        html += '</tr>';
      });

      html += '</tbody></table>';
      tableWrap.innerHTML = html;

      var ths = tableWrap.querySelectorAll('th[data-idx]');
      for (var j = 0; j < ths.length; j++) {
        (function (th) {
          th.addEventListener('click', function () {
            var idx = parseInt(th.getAttribute('data-idx'), 10);
            if (sortCol === idx) { sortDir *= -1; } else { sortCol = idx; sortDir = 1; }
            render(input.value.trim());
          });
        })(ths[j]);
      }
    }

    input.addEventListener('input', function () {
      if (clearBtn) clearBtn.style.display = input.value ? 'inline-flex' : 'none';
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        render(input.value.trim());
      }, 100);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        clearBtn.style.display = 'none';
        render('');
        input.focus();
      });
    }

    render('');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();